import { addSeconds, formatDistanceStrict } from "date-fns";

export const formatSecondsLabel = (seconds: number) => {
  const baseDate = new Date(0);
  const targetDate = addSeconds(baseDate, seconds);
  const formatted = formatDistanceStrict(baseDate, targetDate, {
    roundingMethod: "floor",
  });

  return formatted
    .replace("seconds", "sec")
    .replace("second", "sec")
    .replace("minutes", "min")
    .replace("minute", "min")
    .replace("hours", "h")
    .replace("hour", "h");
};
